const PROTOCOLS = ['http://', 'https://'];

const linkStartsWithProtocol = (link) =>
  PROTOCOLS.some((protocol) => link.startsWith(protocol));

export default linkStartsWithProtocol;
